import React from "react";
import InputFactory from "../../../../components/InputFactory";
import { dialog } from "../../../../nq-component";
import { set } from "date-fns";

function DialogUploadQC({ handleFileChange, handleSubmit }) {
  const [quitClaim, setQuitClaim] = React.useState(null);

  const _handleFileChange = (value, field) => {
    setQuitClaim(value);
    handleFileChange(value);
  };

  return (
    <>
      <div className="p-4">
        <div className="d-flex flex-column align-items-center gap-3">
          <div className="d-flex align-self-start align-items-center gap-2">
            <i
              className="bi bi-file-earmark-arrow-up fs-2 px-2 rounded"
              style={{ backgroundColor: "#F5F5F5", color: "#D18237" }}
            ></i>
            <h5 className="fw-bold mt-2" style={{ color: "#D18237" }}>
              Upload Quitclaim
            </h5>
          </div>
        </div>
      </div>
      <div className="d-flex flex-column gap-2 pb-4 px-5">
        <label>
          Upload Quitclaim Document <span className="text-danger">*</span>
        </label>
        <InputFactory
          type="File"
          _type="File"
          required
          className="form-control bg-light-subtle p-2 align-self-center"
          placeholder="Diploma"
          field="quitClaim"
          onChange={(value, field) => _handleFileChange(value, field)}
        />
      </div>

      <div className="text-center mb-3">
        <button
          type="submit"
          className="btn text-white me-2"
          disabled={!quitClaim}
          style={{ backgroundColor: "#D18237" }}
          onClick={handleSubmit}
        >
          Confirm
        </button>
        <button
          type="button"
          className="btn"
          style={{ backgroundColor: "#e8ecf3" }}
          onClick={() => dialog.close()}
        >
          Cancel
        </button>
      </div>
    </>
  );
}

export default DialogUploadQC;
